module.exports = __webpack_public_path__ + "static/media/wbm_ico.1b69a9fe.png";